import { gql } from '@apollo/client';
const ADD_MODEL_COLOR = gql `
  mutation AddModelColor($modelSpecificationId: ID!, $colorName: String!) {
    addModelSpecificationColor(modelSpecificationId: $modelSpecificationId, colorName: $colorName) {
      modelSpecificationColor {
        id
        name
      }
    }
  }
`;
export default ADD_MODEL_COLOR;
